module.exports = __webpack_public_path__ + "static/media/16_tn.56cc8fcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/16_tn.jpg
// module id = 652
// module chunks = 0